import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { UserIdleService } from "angular-user-idle";
import { LoginService } from "../account/login/login.service";
import { EventService } from "../core/services/event.service";
import { HttpService } from "../shared/http.service";
import { LAYOUT_VERTICAL } from "./layout.model";
import { MENU } from "./sidebar/menu";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ConfirmationDialogService } from "../shared/confirmation-dialog/confirmation-dialog.service";

@Component({
  selector: "app-layout",
  templateUrl: "./layout.component.html",
  styleUrls: ["./layout.component.scss"],
})

/**
 * Layout Component
 */
export class LayoutComponent implements OnInit {
  layoutType!: string;
  appInfo: any = {};
  userName: string = "";
  userProfileImageHandler: string = "";
  user: any = {};
  ordering: any = [];
  menu: any = [];
  permissions: any;
  subscriptions: any = [];
  public istimeOut: boolean = false;

  constructor(
    private eventService: EventService,
    private loginService: LoginService,
    private userIdle: UserIdleService,
    private httpService: HttpService,
    public router: Router,
    public ngbModal: NgbModal,
    public confirmationDialogService: ConfirmationDialogService,
  ) {
    let that = this;
    that.userIdle.startWatching();
    that.userIdle.onTimerStart().subscribe();
    that.userIdle.onTimeout().subscribe(() => {
      if (that.istimeOut) {
        that.confirmationDialogService.isIdle = true;
        that.istimeOut = !that.istimeOut;
        that.loginService.logout();
        that.userIdle.stopWatching();
        setTimeout(() => {
          location.reload();
        }, 3000); 
      }
    });
  }


  ngOnInit(): void {
    this.layoutType = LAYOUT_VERTICAL;

    // listen to event and change the layout, theme, etc
    this.eventService.subscribe("changeLayout", (layout) => {
      this.layoutType = layout;
    });
    let that = this;
    var count = 0;
    let menus = that.httpService.menus();
    let filteredMenus = menus.filter(x => x.AccessTypeId != null);
    that.permissions = filteredMenus.map(x => x.Id);
    for (var i = 0; i < MENU.length; i++) {
      if (MENU[i].link == '') {
        for (var j = 0; j < MENU[i].permissions.length; j++) {
          that.ordering[count] = MENU[i].permissions[j];
          that.menu.push(MENU[i].subItems[j]);
          count++;
        }
      }
      else {
        that.ordering[count] = MENU[i].permissions[0];
        that.menu.push(MENU[i]);
        count++;
      }
    }
    that.checkTokenLife();
    that.istimeOut = true;
    that.userProfileImageHandler = that.httpService.userProfileImageHandler();
    that.userName = that.httpService.userName();
    that.appInfo = that.httpService.appInfo();
    if (that.router.url === '/') {
      that.goTohome();
    }
  }

  isVerticalLayoutRequested() {
    return this.layoutType === LAYOUT_VERTICAL;
  }


  logout() {
    this.loginService.logout();
    this.userIdle.resetTimer();
    this.userIdle.stopTimer();
    this.userIdle.stopWatching();
    this.subscriptions.forEach((subscription: { unsubscribe: () => any; }) => subscription.unsubscribe());
  }

  checkTokenLife() {
    let that = this;
    that.user = JSON.parse(localStorage.getItem('currentUser') || '{}');
    if (that.user) {
      let tokenTime = ((new Date().getTime() - that.user.tokenTime) / 1000) / 3600;
      if (tokenTime > that.user.tokenLife) {
        that.loginService.logout();
      }
    }
    else {
      that.loginService.logout();
    }
  }

  goTohome(){
    let that = this;
    let activemenu: any;
    for (var i = 0; i < that.ordering.length; i++) {
      let activePermission = that.permissions.find((x: any) => x == that.ordering[i]);
      if (activePermission != undefined) {
        activemenu = that.menu.find((m: { permissions: any[]; }) => m.permissions[0] == activePermission);
        if (activemenu) {
          break;
        }
      }
    }
    if (activemenu) {
      that.router.navigate([activemenu.link]);
    }
    else {
      that.router.navigate(['/profile']);
    }
  }
}
